import React from "react";
import {observer} from "mobx-react";
import CurrentPortal from "../../current-portal/current-portal";
import merchantStoresMenuStore from "../../merchant-portal-menu-list-store";
import Icon from "../../../../../../icons/icon/icon";
import IconNext from "../../../../../../icons/icon-next/icon-next";

type TableContentsProps = {
    isMenuOpen: boolean;
}

const ToggleContents: React.FC<TableContentsProps> = observer(({ isMenuOpen }) => {
    const selectedPortal = merchantStoresMenuStore.selectedPortal;

    let mainPortal = null;
    let secondaryPortal = null

    if (selectedPortal) {
        mainPortal = selectedPortal.isMain ? selectedPortal : selectedPortal.mainPortal;
        secondaryPortal = !selectedPortal.isMain ? selectedPortal : null;
    }

    return (
        <div className="portal-selection__toggle-contents">
            {mainPortal && <CurrentPortal portalName={mainPortal.label} secondaryPortalName={secondaryPortal?.label} />}
            {!mainPortal && "Select store/portal"}
            <div className={`portal-selection__toggle-contents__arrow ${isMenuOpen ? 'is-expanded' : ''}`}>
                <Icon color={'var(--color-primary-2)'} Component={IconNext} />
            </div>
        </div>
    );
});

export default ToggleContents;